export const FBmsgIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 0C3.05669 0 0 2.88849 0 6.79001C0 8.83077 0.83636 10.5942 2.19839 11.8122C2.31273 11.9146 2.38175 12.0579 2.38644 12.2114L2.42456 13.4565C2.43674 13.8537 2.847 14.1122 3.21044 13.9517L4.59984 13.3384C4.71762 13.2864 4.8496 13.2768 4.97371 13.3109C5.61218 13.4865 6.29171 13.58 7 13.58C10.9433 13.58 14 10.6915 14 6.79001C14 2.88849 10.9433 0 7 0Z"
        fill="url(#paint0_radial_820_13829)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.79653 8.77572L4.85278 5.51343C5.17986 4.99445 5.88028 4.86523 6.37105 5.23329L8.00649 6.45988C8.15654 6.57244 8.363 6.57184 8.51242 6.45844L10.7212 4.78214C11.016 4.55842 11.4008 4.91122 11.2035 5.22431L9.14725 8.48662C8.82014 9.00557 8.11972 9.13482 7.62898 8.76673L5.9935 7.54012C5.84346 7.42759 5.63699 7.42819 5.48758 7.54159L3.27883 9.21788C2.98403 9.44159 2.5992 9.08879 2.79653 8.77572Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_820_13829"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(2.69458 13.9251) scale(15.2544)"
        >
          <stop stopColor="#0099FF" />
          <stop offset="0.60975" stopColor="#A033FF" />
          <stop offset="0.93482" stopColor="#FF5280" />
          <stop offset="1" stopColor="#FF7061" />
        </radialGradient>
      </defs>
    </svg>
  );
};
